import React, { useEffect, useState } from 'react';
import { useApi } from '../../hooks/useApi';
import { useClub } from '../../hooks/useClub';

export default function LeadProspects({ onSelectProspect }) {
  const { get } = useApi();
  const { currentClub } = useClub();
  const [prospects, setProspects] = useState([]);
  const [loading, setLoading]     = useState(true);
  const [search, setSearch]       = useState('');
  const [pipelineFilter, setPipelineFilter] = useState('');

  // eslint-disable-next-line react-hooks/exhaustive-deps
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    setLoading(true);
    const url = `/lead/prospects?club=${currentClub.id}${pipelineFilter ? `&pipeline=${pipelineFilter}` : ''}`;
    get(url)
      .then(d => setProspects(d.prospects || []))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [currentClub.id, pipelineFilter]);

  const PIPELINE_OPTIONS = [
    { value: 'lead_engine', label: 'Lead Engine' },
    { value: 'trial_ready', label: 'Trial Ready' },
    { value: 'win_back_non_member', label: 'Win Back — Non-Member' },
    { value: 'win_back_past_member', label: 'Win Back — Past Member' },
  ];

  const filtered = prospects.filter(p =>
    p.name.toLowerCase().includes(search.toLowerCase()) ||
    (p.phone || '').includes(search) ||
    (p.pipeline || '').toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      <div style={{ marginBottom: '1rem', display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        <input
          className="field-input"
          placeholder="Search by name, phone, or pipeline..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{ maxWidth: 360 }}
        />
        <select
          className="field-select"
          value={pipelineFilter}
          onChange={e => setPipelineFilter(e.target.value)}
          style={{ maxWidth: 220 }}
        >
          <option value="">All Pipelines</option>
          {PIPELINE_OPTIONS.map(p => (
            <option key={p.value} value={p.value}>{p.label}</option>
          ))}
        </select>
        {pipelineFilter && (
          <button
            onClick={() => setPipelineFilter('')}
            style={{ background: 'none', border: '1px solid var(--border)', color: 'var(--text-muted)', borderRadius: 5, padding: '4px 10px', fontSize: 11, cursor: 'pointer' }}
          >✕ Clear</button>
        )}
      </div>

      {loading ? (
        <div className="empty-state"><div className="spinner" /></div>
      ) : (
        <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 'var(--radius-lg)', overflow: 'hidden' }}>
          <table className="data-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Pipeline</th>
                <th>Contact Method</th>
                <th>Status</th>
                <th>Last Contact</th>
                <th>Score</th>
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 && (
                <tr><td colSpan={6} style={{ textAlign: 'center', color: 'var(--text-muted)', padding: '2rem' }}>No records found</td></tr>
              )}
              {filtered.map(p => (
                <tr key={p.id} style={{ cursor: 'pointer' }} onClick={() => onSelectProspect(p.id)}>
                  <td style={{ fontWeight: 500 }}>{p.name}</td>
                  <td><span className="badge badge-gray">{p.pipeline}</span></td>
                  <td style={{ color: 'var(--text-secondary)', fontSize: 12 }}>{p.contactMethod || '—'}</td>
                  <td><LeadStatusBadge status={p.status} /></td>
                  <td style={{ color: 'var(--text-secondary)', fontSize: 12 }}>{p.lastContact || '—'}</td>
                  <td style={{ fontFamily: 'var(--font-mono)', color: 'var(--text-secondary)' }}>{p.score ?? '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

function LeadStatusBadge({ status }) {
  if (status === 'converted') return <span className="badge badge-green">Converted</span>;
  if (status === 'lost')      return <span className="badge badge-gray">Lost</span>;
  if (status === 'dnc')       return <span className="badge badge-red">DNC</span>;
  if (status === 'declined')  return <span className="badge badge-gray">Declined</span>;
  return <span className="badge badge-blue">Active</span>;
}